import React from 'react'
import DashHeader from '../../Components/DashboardCom/Header/DashHeader'
import DashRequest from '../../Components/DashboardCom/DashRequest'
import Footer from '../../Components/Footer/Footer'
const DashRequestPage = () => {
  return (
    <div>
        <DashHeader />
        <DashRequest />
        {/* <Footer /> */}
    </div>
  )
}

export default DashRequestPage